export default "/images/globe-icon-gray.png?24785c56812003d10af23ddafdb44f11";